import {
  Switzerland,
  RequiredCandidate,
  ValidationFields,
  Language,
  RequiredCandidateExpert,
} from "../../data/constants";
import { CandidateViewModel } from "../../model/CandidateViewModel";
import { PersonType } from "../../model/PersonType";

export const initialCandidate: CandidateViewModel = {
  emailAddress: "",
  city: "",
  mobileNumber: "",
  firstName: "",
  phoneNumber: "",
  id: "",
  lastName: "",
  street: "",
  streetNumber: "",
  zipCode: "",
  blocked: false,
  gender: "",
  nationality: "",
  preferredContact: "",
  ahvNumber: "",
  ciceroNumber: "",
  bankAccount: "",
  birthdate: new Date(1900, 1, 1),
  canton: "",
  correspondenceLanguage: Language.DE,
  country: Switzerland,
  employer: "",
  employerCity: "",
  employerCountry: Switzerland,
  employerStreet: "",
  employerZipCode: "",
  nationalityIsSwiss: true,
  placeOfOrigin: "",
  privateIsPreferredContact: true,
  disablePersonalFields: false,
  type: PersonType.Candidate,
  languages: [],
  rolesWithExamsAndCourseTypes: [],
  hasEmptyPersonalFields: false,
  internalComment: "",
};

export const initialRequiredCandidateExpertFields = (): RequiredCandidateExpert => ({
  isBankAccountEmpty: false,
  hasEmptyRoleArray: [],
  hasEmptyRole: false,
});

export const initialRequiredFields = (): RequiredCandidate => ({
  isFirstnameEmpty: false,
  isLastnameEmpty: false,
  isGenderEmpty: false,
  isBirthDateEmpty: false,
  isEmailEmpty: false,
  isStreetEmpty: false,
  isStreetNumberEmpty: false,
  isZipCodeEmpty: false,
  isCityEmpty: false,
  isCountryEmpty: false,
  isLanguageEmpty: false,
  isAhvNoEmpty: false,
  isNationalityEmpty: false,
  isPlaceOfOriginEmpty: false,
  isCantonEmpty: false,
  isEmployerInformationEmpty: false,
});

export const initialValidationFields: ValidationFields = {
  isAhvValid: false,
  isCiceroValid: false,
  isEmailValid: false,
  isMobileValid: false,
  isPhoneValid: false,
};
